import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getGlobalStakingStats, { GetGlobalStakingStatsInput, GetGlobalStakingStatsOutput } from '.';

type TrimmedGetGlobalStakingStatsInput = Omit<GetGlobalStakingStatsInput, 'dlVaultContract'>;

export type UseGetGlobalStakingStatsQueryKey = [
  FunctionKey.GET_GLOBAL_STAKING_STATS,
  TrimmedGetGlobalStakingStatsInput,
];

type Options = QueryObserverOptions<
  GetGlobalStakingStatsOutput,
  Error,
  GetGlobalStakingStatsOutput,
  GetGlobalStakingStatsOutput,
  UseGetGlobalStakingStatsQueryKey
>;

const useGetGlobalStakingStats = (input: TrimmedGetGlobalStakingStatsInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_GLOBAL_STAKING_STATS, input],
    () => getGlobalStakingStats({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetGlobalStakingStats; 